/**
 * Fetch function to handle request and response from the specified endpoint.
 *
 * @param {string} url Endpoint URL
 * @param {string} [method] Request method, defaults to GET
 * @param {object} [body] Request body (only used if method is POST)
 * @param {object} [headers] Request headers (using the new Headers constructor)
 * @returns
 */
export const useFetch = async (url, method = 'GET', body, headers) => {
  const params = {
    method
  }

  if (body && method === 'POST') {
    // Ex:
    // {
    //   param 1: 'value 1',
    //   param 2: 'value 2'
    // }
    if (typeof body === 'string' || body instanceof String) params.body = body
    else params.body = JSON.stringify(body)
  }
  if (headers) {
    // Ex:
    // {
    //   headers: new Headers({
    //     'Header-name': 'Header content'
    //   })
    // }
    params.headers = headers
  }

  const request = await fetch(url, params)

  const response = await request.json()

  //TODO: Add better error handling?
  // if (response.status !== 200 || response.meta.apiResponse?.status === 204) return null

  return { response, status: request.status }
}
